import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  TemplateRef,
  input,
} from '@angular/core';
import { CarouselComponent } from 'src/app/account/components/carousel/carousel.component';

@Component({
    selector: 'app-bid-showcase',
    templateUrl: './bid-showcase.component.html',
    styleUrls: ['./bid-showcase.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, CarouselComponent]
})
export class BidShowcaseComponent {
  @ContentChild(TemplateRef) template: TemplateRef<any>;

  elementList = input<any[]>([]);

  displayInCarousel = input<boolean>(false);
  stateKey = input<string | null>(null);
}
